import { setSelectedCategoryId } from '../../utils/variables';

export function selectCategory(id) {
    removeAllSelectCategory();
    setSelectedCategoryId(id);

    const categoryOption = document.querySelector(
        `.category-item__option[data-category-id="${CSS.escape(id)}"]`
    );

    categoryOption?.classList.add('is-selected');
}

export function removeAllSelectCategory() {
    setSelectedCategoryId('');

    document
        .querySelectorAll('.category-item__option')
        .forEach((i) => i.classList.remove('is-selected'));
}

